/**
 * The CRF routes — Figma page 03's six screens, mounted through the
 * `routes.extra.ts` seam (v7 Block A).
 *
 * Paths: `crfs` is the one `domain/nav.ts` reserved in Phase 3 and has pointed
 * at (available:false) ever since — mounting it is what turns that entry from a
 * dead reservation into a screen. The confirmation register rides UNDER `crfs/`
 * (`crfs/confirmations`) because the design's own breadcrumb says "CRFs / Work
 * Confirmation" (37:7004) — it is a CRF sub-page, not a sidebar destination, so
 * it deliberately gets NO nav row (the work/:id precedent).
 *
 * ⚠ ORDER: `confirmations` and `new` are declared BEFORE `:crfId` — a router
 * that matched `:crfId` first would treat both words as record ids. The same
 * route-order trap the API's status-counts controller documents, on the client.
 *
 * One pathless `CrfProviders` layout so a toast survives the navigation that
 * raised it (create → record, save → register).
 */

import type { RouteObject } from 'react-router-dom';

import { CrfsListPage } from './CrfsListPage';
import { CrfCreatePage } from './CrfCreatePage';
import { CrfRecordPage } from './CrfRecordPage';
import { WorkConfirmationPage } from './WorkConfirmationPage';
import { ConfirmationEntryPage } from './ConfirmationEntryPage';
import { CrfProviders } from './providers';

export const crfRoutes: RouteObject[] = [
  {
    element: <CrfProviders />,
    children: [
      { path: 'crfs', element: <CrfsListPage /> },
      { path: 'crfs/new', element: <CrfCreatePage /> },
      { path: 'crfs/confirmations', element: <WorkConfirmationPage /> },
      { path: 'crfs/:crfId', element: <CrfRecordPage /> },
      { path: 'crfs/:crfId/confirmation', element: <ConfirmationEntryPage /> },
    ],
  },
];
